import z from 'zod';

export const asvParams = z.object({
  teamUuid: z.string().nonempty(),
  appUuid: z.string().nonempty(),
});

export const asvTargetParams = asvParams.extend({
  targetUuid: z.string().nonempty(),
});

export const asvScanParams = asvParams.extend({
  scanRunUuid: z.string().nonempty(),
});

export const asvVulnerabilityParams = asvParams.extend({
  vulnerabilityUuid: z.string().nonempty(),
});
